module.exports = __webpack_public_path__ + "img/collections.1992c900.svg";